"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhiteButton = void 0;
var white_button_1 = require("./white-button");
Object.defineProperty(exports, "WhiteButton", { enumerable: true, get: function () { return white_button_1.WhiteButton; } });
//# sourceMappingURL=index.js.map